(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["depict-patched-main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["la-store"] && !Shopify.designMode) return;
  try {
    
  function initStoreStatus() {
    document.querySelectorAll('[id^="store-open-status-"]').forEach(function(el) {
      if (el._storeStatusInit) return;
      el._storeStatusInit = true;

      var tz = el.dataset.timezone || 'America/Los_Angeles';
      var dayHours = {};
      try { dayHours = JSON.parse(el.dataset.hours || '{}'); } catch(e) {}

      var HOLIDAY_HOURS = {
        '12/24': { open: 10 * 60, close: 17 * 60 },
        '12/25': null,
        '12/31': { open: 10 * 60, close: 17 * 60 },
      };

      function getTimeParts(now) {
        now = now || new Date();
        var parts = new Intl.DateTimeFormat('en-US', {
          timeZone: tz,
          weekday: 'long', month: '2-digit', day: '2-digit',
          hour12: false, hour: '2-digit', minute: '2-digit',
        }).formatToParts(now);

        var weekday = '', month = '', day = '', hour = 0, minute = 0;
        for (var i = 0; i < parts.length; i++) {
          var p = parts[i];
          if (p.type === 'weekday') weekday = p.value;
          else if (p.type === 'month') month = p.value;
          else if (p.type === 'day') day = p.value;
          else if (p.type === 'hour') hour = parseInt(p.value, 10);
          else if (p.type === 'minute') minute = parseInt(p.value, 10);
        }
        return { weekday: weekday, mmdd: month + '/' + day, minutes: hour * 60 + minute };
      }

      function getTodaysHours(now) {
        var tp = getTimeParts(now);
        if (Object.prototype.hasOwnProperty.call(HOLIDAY_HOURS, tp.mmdd)) return HOLIDAY_HOURS[tp.mmdd];
        var dh = dayHours[tp.weekday];
        if (!dh || dh.closed) return null;
        return { open: dh.open, close: dh.close };
      }

      function formatMinutes12(mins) {
        var h24 = Math.floor(mins / 60);
        var m = mins % 60;
        var suffix = h24 >= 12 ? 'PM' : 'AM';
        var h12 = ((h24 + 11) % 12) + 1;
        return h12 + (m ? ':' + String(m).padStart(2, '0') : '') + ' ' + suffix;
      }

      function update() {
        var dot = el.querySelector('.dot');
        var text = el.querySelector('.text');
        if (!dot || !text) return;

        var todaysHours = getTodaysHours();
        var tp = getTimeParts();
        var isOpen = todaysHours ? (tp.minutes >= todaysHours.open && tp.minutes < todaysHours.close) : false;

        dot.classList.toggle('open', isOpen);
        dot.classList.toggle('closed', !isOpen);

        if (isOpen && todaysHours) {
          text.innerHTML = 'We\'re open <span class="until">until ' + formatMinutes12(todaysHours.close) + '</span>';
        } else {
          text.innerHTML = '<span class="closed">We\'re currently closed</span>';
        }
      }

      update();
      setInterval(update, 60 * 1000);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initStoreStatus);
  } else {
    initStoreStatus();
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection-sale-grid"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
